module.exports = __webpack_public_path__ + "media/images/swiss/offers/digital-voucher-d72f485d031265e22c7377dcd25d3c69.jpg";